module.exports = __webpack_public_path__ + "9b160de852be7761b3e6b855939cbd45.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/payment/social-6.jpg
// module id = ./assets/images/payment/social-6.jpg
// module chunks = 0